
import React from 'react';
import { useParams } from 'react-router-dom';
import Shop from './Shop';

const ShopByCategory = () => {
  const { categoryId, subcategoryId } = useParams();
  
  return (
    <Shop />
  );
};

export default ShopByCategory;
